const PRODUCT_ADDRESS = 'zabus.ru';
const DEVELOP_ADDRESS = '192.168.0.3';

export const API_PRODUCT = `https://api.${PRODUCT_ADDRESS}`;
export const API_DEVELOP = `https://api.${PRODUCT_ADDRESS}`; //`http://${DEVELOP_ADDRESS}:5050`;

export const PLATFORM_PRODUCT = `https://lk.${PRODUCT_ADDRESS}`;
export const PLATFORM_DEVELOP = `http://${DEVELOP_ADDRESS}:${process.env.PORT || 3006}`;
